import axiosInstance from "../axiosInstance";

export const countryService = {
  fetchAll: async () => {
    const response = await axiosInstance.get("/client-country-options");
    return response.data.data;
  },
};
